import { render, staticRenderFns } from "./AlarmListLink.vue?vue&type=template&id=f847b6c8&scoped=true&"
import script from "./AlarmListLink.vue?vue&type=script&lang=js&"
export * from "./AlarmListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f847b6c8",
  null
  
)

export default component.exports